<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar = !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5" id="grad1">
          <!-- breadcrumb and title row starts -->
          <div class="row">
            <div class="col-sm-12">
              <vs-breadcrumb
                align="left"
                :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/program-officer/todoList'
                  },

                  {
                    title: 'Training Wizard',
                    active: true
                  }
                ]"
              ></vs-breadcrumb>
            </div>
            <div class="col-sm-12">
              <div class="heading mt-3">
                <h3 class="text-secondary">Training Wizard</h3>
              </div>
            </div>
          </div>
          <!-- breadcrumb and title row Ends -->
          <div class="row justify-content-center mt-0">
            <div class="col-11 text-center p-0 mt-3 mb-2">
              <div class="card px-0 pb-0 mt-3 mb-3">
                <div class="row">
                  <div class="col-md-12 mx-0">
                    <form id="msform" @submit.prevent="TrainingForm">
                      <!-- progressbar -->
                      <ul id="progressbar">
                        <li title="Warning! You are not authorized to access." id="NewTraining">
                          <strong>Training Assignment</strong>
                        </li>
                        <li title="Warning! You are not authorized to access." id="PoAssignment">
                          <strong>P.O Assignment</strong>
                        </li>
                        <li class="active" id="TrainingInformation">
                          <strong>Training Information</strong>
                        </li>
                        <li @click="trainerRegistration()" id="TrainerRegistration">
                          <strong>Trainer Registration</strong>
                        </li>
                        <li @click="trainingAgenda()" id="TrainingAgenda">
                          <strong>Training Agenda</strong>
                        </li>
                        <li @click="trainingAssessment()" id="TrainingAssessments">
                          <strong>Training Assessments</strong>
                        </li>
                        
                        <li @click="traineeReg()" id="TraineeRegistration">
                          <strong>Trainee Registration</strong>
                        </li>
                        <li @click="assessmentReviewFunction()" id="AssessmentReview">
                          <strong>Assessment Review</strong>
                        </li>
                        <li @click="trainingCompletion()" id="Completion">
                          <strong>Completion</strong>
                        </li>
                      </ul>
                      <!-- fieldsets -->
                      <fieldset style="text-align: left;padding: 30px;">
                        <h5>Training Information</h5>
                        <!-- row 1 starts  -->
                        <div class="row mt-5">
                          <!--  col-md-6   -->
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first">Training Title</label>
                              <input
                                style="opacity: 1 !important;background-color: #d3d3d3;"
                                type="text"
                                class="form-control form-control-sm"
                                placeholder="Terrorism Investigation Course"
                                disabled
                                id="first"
                                :value="updateTraining.title"
                              />
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first">Sub Program</label>
                              <input
                                style="opacity: 1 !important;background-color: #d3d3d3;"
                                type="text"
                                class="form-control form-control-sm"
                                placeholder="Terrorism Investigation Course"
                                disabled
                                id="first"
                                :value="updateTraining.subprogram.title"
                              />
                            </div>
                          </div>
                          <!--  col-md-6   -->
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first">Project</label>
                              <select
                                style="opacity: 1 !important;background-color: #d3d3d3;"
                                class="form-control form-control-sm"
                                id="exampleFormControlSelect1"
                                disabled
                              >
                                <option
                                  :value="updateTraining.project.id"
                                  selected
                                >{{updateTraining.project.title}}</option>
                              </select>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first">Doner Name</label>
                              <selectize
                                id="select-state"
                                disabled
                                v-model="donerSelected"
                                :settings="donersettings"
                              >
                                <option
                                  v-for="(item,index) in selectedDoner"
                                  :key="index"
                                  :value="item.id"
                                  disabled
                                >{{item.title}}</option>
                              </selectize>
                            </div>
                          </div>
                        </div>
                        <!-- row 1 ends -->
                        <!-- row 2 starts  -->
                        <div class="row">
                          <!--  col-md-6   -->

                          <!--  col-md-6   -->
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first">Department</label>
                              <selectize
                                id="select-state"
                                v-model="department"
                                :settings="departmentsettings"
                              >
                                <option
                                  v-for="(item,index) in departmentArr"
                                  :key="index"
                                  :value="item.id"
                                >{{item.title}}</option>
                              </selectize>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first">Type</label>
                             <selectize v-model="type_training"> <!-- settings is optional -->
                                <option
                                  v-for="(tType,index) in trainingTypeArr"
                                  :key="index"
                                  :value="tType.id"
                                >{{tType.title}}</option>
                              </selectize>
                            </div>
                          </div>
                        </div>
                        <!-- row 2 ends -->
                        <!-- row 3 starts  -->
                        <div class="row">
                          <!--  col-md-6   -->

                          <!--  col-md-6   -->
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first">Date Range </label>
                              <small class="text-info"> (Note: To choose one day, double click on specific date)</small>
                              <flat-pickr
                                class="form-control"
                                style="background: #fff;opacity:1"
                                placeholder="Start date Range"
                                v-model="dateRange"
                                :config="dateOptions"
                              ></flat-pickr>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label style="font-weight:700;" for="first">Days</label>
                              <input
                                class="floating-input form-control"
                                v-model="noOfDays"
                                type="text"
                                disabled
                                placeholder=" "
                              />
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-6">
                            <label style="font-weight:700;" for="first">Location</label>
                            <selectize id="select-state" v-model="district">
                              <option
                                v-for="(item,index) in cityArr"
                                :key="index"
                                :value="item.id"
                              >{{item.title}}, {{item.province.title}}, {{item.province.country.title}}</option>
                            </selectize>
                          </div>
                          <div class="col-md-6">
                            <label style="font-weight:700;" for="first">
                              Contact Person
                              <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                            </label>
                            <input
                              class="floating-input form-control"
                              v-model="contact_person"
                              type="text"
                              placeholder=" "
                            />
                          </div>
                          <div class="col-md-6 col-lg-6" style="margin-top:10px;">
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                v-model="contact_number"
                                type="text"
                                v-mask="'(9999) 9999999'"
                                placeholder=" "
                              />
                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i class="material-icons" style="font-size: 20px;">call</i>
                              </span>
                              <label class="lbl-label">
                                Contact Number
                                <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                              </label>
                            </div>
                          </div>
                          <!-- <div class="col-md-6" style="margin-top:10px;">
                            <input
                              class="floating-input form-control"
                              v-model="contact_email"
                              type="email"
                              placeholder=" "
                            />
                            <span
                              class="lbl-label"
                              style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                            >
                              <i class="material-icons" style="font-size: 20px;">email</i>
                            </span>
                            <label class="lbl-label">
                              Email
                              <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                            </label>
                          </div> -->
                          <!-- floating input starts -->
                          <!-- email starts -->
                          <div class="col-md-6" style="margin-top:10px;">
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                v-model="contact_email"
                              type="email"
                                placeholder=" "
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i class="material-icons" style="font-size: 20px;">email</i>
                              </span>
                              <label class="lbl-label">
                                Email
                                <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                              </label>
                            </div>
                          </div>
                          <!-- email ends -->
                          <!-- floating input ends -->
                        </div>
                        <div class="row">
                          <!-- floating input starts -->
                          <div class="col-md-6" style="margin-top:10px;">
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                v-model="address"
                                type="text"
                                placeholder=" "
                                 autocomplete="off"
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i class="material-icons" style="font-size: 20px;">place</i>
                              </span>
                              <label class="lbl-label">
                                Address
                                <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                              </label>
                            </div>
                          </div>
                          <!-- floating input ends -->
                          <!-- Address Ends -->
                          <!-- floating input starts -->
                          <div class="col-md-12 col-lg-12" style="margin-top:10px;">
                            <div class="floating-label">
                              <input
                                class="floating-input form-control"
                                v-model="venue"
                                type="text"
                                placeholder=" "
                                 autocomplete="off"
                              />

                              <span
                                class="lbl-label"
                                style="float: right;padding: 0px 5px;margin-top: -30px; color:#ccc;"
                              >
                                <i class="material-icons" style="font-size: 20px;">account_balance</i>
                              </span>
                              <label class="lbl-label">
                                Venue
                                <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <!-- Next Step Button Starts  -->
                        <div class="row">
                          <div class="col-md-12 text-right">
                            <router-link
                              to="/dashboard/program-officer/todoList"
                              class="btn btn-primary btn-sm m-1"
                            >Cancel</router-link>
                            <b-button
                              class="btn btn-primary btn-sm"
                              type="submit"
                              variant="primary"
                            >Save & Next</b-button>
                            <!--  <router-link
                              :to="{ path: '/dashboard/admin/training-agenda', query: { trainingId: this.trainingCode}}"
                              class="btn btn-primary btn-sm"
                            >Save & Next</router-link>-->
                            <!-- <button type="button" class="btn btn-primary btn-sm">Next Step</button> -->
                          </div>
                        </div>

                        <!-- Next Step Button Ends  -->
                      </fieldset>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Selectize from "vue2-selectize";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";

// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  data: () => ({
   
    inValid: [],
    training_id:'',
    updateTraining: "",
    donernameArr: [],
    departmentArr: [],
    dateRange: [],
    dateOptions: {
      wrap: true,
      weekNumbers: true,
      mode: "range",
      maxDate: new Date().fp_incr(10),
      dateFormat: "d-m-Y"
    },
    // subprogramArr: [],
    isSidebar: false,
    isForm: true,
    isFormData: false,
    selected: "",
    subprogramSelected: "",
    project_title: "",

    subprogramsettings: {
      maxItems: 3,
      plugins: ["remove_button"],
      delimiter: "|"
    },
    departmentsettings: {
      maxItems: 10,
      plugins: ["remove_button"],
      delimiter: "|"
    },
    donerSelected: [],
    donersettings: {
      maxItems: 5,
      plugins: ["remove_button"],
      delimiter: "|"
    }, // https://github.com/selectize/selectize.js/blob/master/docs/usage.md

    contact_person: "",
    trainingId: "",
    trainingCode: "",
    contact_number: "",
    contact_email: "",
    address: "",
    options: {
      format: "DD/MM/YYYY",
      useCurrent: false
    },
    textarea: "",
    venue: "",
    counterDanger: false,
    mydate: "",
    startDate: "",
    agendasArray: [],
    agendasArraySecond: [],
    agendasArrayThird: [],
    newArr: [],
    newArrSecond: [],
    newArrThird: [],
    endDate: "",
    colorx: "#1db952",
    indexActive: 0,
    trainingCheck: false,
    repeatedCheck: false,
    selectedDoner: [],
    select1Normal: "",
    training_title: "",
    select2: 1,
    select3: 1,
    type_training: "",
    country: "",
    province: "",
    district: "",
    department: [],
    // project_title: 1,
    trainingtitleArr: [],
    projecttitleArr: [],

    trainingTypeArr: [],
    countryArr: [],
    provinceArr: [],
    cityArr: [],
    createdTrainingss: "",
    isDataEdit: 0,
    items: [],
    fields: [],
    training_status: "",
  }),
  watch: {
    dateRange(date) {
      // this.startDate = date.split(" to")[0];
      // this.endDate = date.split("to ")[1];
      // this.isDataEdit++;
      // if (this.isDataEdit > 1) {
      //   let daysLengthTotal;
      //   this.startDate = date.split(" to")[0];
      //   this.endDate = date.split("to ")[1];
      //   if (date.includes("to")) {
      //     let daysInRange = document.getElementsByClassName("inRange");
      //     if (this.startDate.split("-")[1] == this.endDate.split("-")[1]) {
      //       daysLengthTotal = daysInRange.length + 2;
      //     } else {
      //       daysLengthTotal = daysInRange.length + 1;
      //     }
      //     this.noOfDays = daysLengthTotal;
      //   }
      // }
      this.startDate = date.split(" to")[0];
      this.endDate = date.split("to ")[1];
      this.isDataEdit++;
      if (this.isDataEdit > 1) {
        let daysLengthTotal;
        this.startDate = date.split(" to")[0];
        this.endDate = date.split("to ")[1];
        if (date.includes("to")) {
          let daysInRange = document.getElementsByClassName("inRange");
          if (this.startDate.split("-")[1] == this.endDate.split("-")[1]) {
            daysLengthTotal = daysInRange.length + 2;
          } else {
            daysLengthTotal = daysInRange.length + 1;
          }
          this.noOfDays = daysLengthTotal;
        } else if(!date.includes("to") && date != ""){
            this.startDate = date;
            this.endDate = date;
            this.noOfDays = 1;
        } else {
          this.startDate = "";
          this.endDate = "";
          this.noOfDays = "";
        }
      }
    }
  },
  mounted() {
    this.trainingCode = this.$route.query.trainingId;

    // Set the initial number of items
    this.totalRows = this.items.length;

    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/countries/get",{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.countryArr = response.data;
        // this.provinceArr=response.data;
      });
    //select all provinces
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/provinces/get",{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.provinceArr = response.data;
      });
    //select all district
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/districts/get",{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.cityArr = response.data;
      });
    //select all department

    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/departments/get",{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.departmentArr = response.data;
      });
    //select all training type
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/trainingtype/get",{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.trainingTypeArr = response.data;
      });

    //this.allTrainings();
    //show all training drop down data
    this.openLoading();
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/programOfficer/trainingsingle/get/" +
          this.trainingCode
      ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.trainingId = response.data.training.id;
        this.training_status = response.data.training.trainingstatus; 
        if (response.data && response.data.training) {
          this.createdTrainingss = response.data.training;
          this.updateTraining = response.data.training;
          this.training_id = this.updateTraining.id
        }

        this.selectedDoner = response.data.doner;
        response.data.doner.forEach(dnr => {
          this.donerSelected.push(dnr.id);
        });
        if (response.data.training.typetraining_id != null) {
          this.type_training = response.data.training.typetraining_id;
        }
        if (
          response.data.training != undefined &&
          response.data.training != null &&
          response.data.training.noofdays
        ) {
          this.noOfDays = response.data.training.noofdays;
        }
        if (
          response.data.training.startdate != null &&
          response.data.training.enddate != null
        ) {
          this.dateRange =
            response.data.training.startdate +
            " to " +
            response.data.training.enddate;
        }

        /*  if (response.data.training.district.province.country.id != null) {
          this.country = response.data.training.district.province.country.id;
        }
        if (response.data.training.district.province.id != null) {
          this.province = response.data.training.district.province.id;
        } */
        if (response.data.training.district_id != null) {
          this.district = response.data.training.district_id;
        }
        if (response.data.training.contact_person != null) {
          this.contact_person = response.data.training.contact_person;
        }
        if (response.data.training.contact_number != null) {
          this.contact_number = response.data.training.contact_number;
        }
        if (response.data.training.email != null) {
          this.contact_email = response.data.training.email;
        }
        if (response.data.training.address != null) {
          this.address = response.data.training.address;
        }
        if (response.data.training.venue != null) {
          this.venue = response.data.training.venue;
        }

        if (response.data.departments && response.data.departments != "") {
          response.data.departments.forEach(department => {
            this.department.push(department.id);
          });
        }
        // this.type_training = response.data.trainingtype.title;
      });
  },
  components: {
    Selectize,
    "app-navbar": Navbar,
    "app-sidebar": Sidebar,
    flatPickr
  },

  methods: {
    // onclick show wizard steps
    trainerRegistration(){
      if(this.training_status == "In Queue"){
        this.$toasted.global.errorMsg("Please complete all steps by clicking on Save & Next button")
      } else {
        this.$router.push({ path: '/dashboard/programOfficer/trainer-registration', query: { trainingId: this.trainingCode }});
      }
    },
    trainingAgenda(){
      
      if(this.training_status == "In Queue"){
        this.$toasted.global.errorMsg("Please complete all steps by clicking on Save & Next button")
      } else {
        this.$router.push({ path: '/dashboard/programOfficer/training-agenda', query: { trainingId: this.trainingCode }});
      }
    },
    trainingMaterial(){
      if(this.training_status == "In Queue"){
        this.$toasted.global.errorMsg("Please complete all steps by clicking on Save & Next button")
      } else {
        this.$router.push({ path: '/dashboard/programOfficer/wizardUploadMaterial', query: { trainingId: this.trainingCode }});
      }
    },
    trainingAssessment(){
      if(this.training_status == "In Queue"){
        this.$toasted.global.errorMsg("Please complete all steps by clicking on Save & Next button")
      } else {
        this.$router.push({ path: '/dashboard/programOfficer/training-assesment', query: { trainingId: this.trainingCode }});
      }
    },
    traineeReg(){
      if(this.training_status == "In Queue"){
        this.$toasted.global.errorMsg("Please complete all steps by clicking on Save & Next button")
      } else {
        this.$router.push({ path: '/dashboard/programOfficer/trainee-registration', query: { trainingId: this.trainingCode }});
      }
    },
    assessmentReviewFunction(){
      if(this.training_status == "In Queue"){
        this.$toasted.global.errorMsg("Please complete all steps by clicking on Save & Next button")
      } else {
        this.$router.push({ path: '/dashboard/programOfficer/assesment-review', query: { trainingId: this.trainingCode }});
      }
    },
    trainingCompletion(){
      if(this.training_status == "In Queue"){
        this.$toasted.global.errorMsg("Please complete all steps by clicking on Save & Next button")
      } else {
        this.$router.push({ path: '/dashboard/programOfficer/wizard-completion', query: { trainingId: this.trainingCode }});
      }
    },


    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 10000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 10000,
        variant: "danger",
        solid: true
      });
    },
    //function used to show all records in table
    /* allTrainings: function allTrainings() {
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/selectTable/training/get/" +
            this.trainingId
        ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.items = response.data;
        });
    }, */
    showinputvalue: function(event) {
      this.name = event.target.value;
    },
    TrainingForm(e) {
      e.preventDefault();
      this.inValid = [];
      if (!this.startDate) {
        this.inValid.push("Start date is required.");
      }
      if (!this.endDate) {
        this.inValid.push("End date is required.");
      }
      if (!this.department || this.department.length < 1) {
        this.inValid.push("Department is required.");
      }
      /* if (!this.country) {
        this.inValid.push("Country is required.");
      }
      if (!this.province) {
        this.inValid.push("Province is required.");
      } */
      if (!this.district) {
        this.inValid.push("District is required.");
      }
      if (!this.contact_person) {
        this.inValid.push("Contact Person is required.");
      }
      if (!this.contact_number) {
        this.inValid.push("Contact Number is required.");
      }
      if (!this.contact_email) {
        this.inValid.push("Contact Email is required.");
      }
      if (!this.address) {
        this.inValid.push("Address is required.");
      }
      if (!this.venue) {
        this.inValid.push("Venue is required.");
      }
      //For phone number validation
      var phone_no = this.contact_number;
      phone_no = phone_no.replace(/_/g, "");
      if (phone_no.length < 14) {
        this.inValid.push("Must be valid Number, 0345-9992229");
      }

      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        // let noAccess = '';
        this.openLoading();
        axios
          .post(
            localStorage.getItem("BASE_PATH") + "/register/update/training",
            {
              user_id: JSON.parse(localStorage.getItem("currentUser")).id,
              trainingId: this.trainingId,
              department: JSON.stringify(this.department),
              type_training: this.type_training,
              startDate: this.startDate,
              endDate: this.endDate,
              district: this.district,
              contact_person: this.contact_person,
              contact_number: this.contact_number,
              contact_email: this.contact_email,
              address: this.address,
              venue: this.venue,
              noOfDays: this.noOfDays,
              training_id:this.training_id
            },{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
         
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
            this.closeLoading();
            if (response.data.success) {
              self.$toasted.global.successMsg("Record has been updated successfully!");
              self.resetForm();
              //self.allTrainings();
              this.$router.push({
                name: "wizardTrainerRegistration",
                query: { trainingId: this.trainingCode }
              });
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.$toasted.global.errorMsg(error);
          });
      }
    },
    resetForm() {
      this.department_name = "";
      this.type_training = "";
      this.contact_email = "";
      this.address = "";
      this.contact_person = "";
      this.contact_number = "";
      this.venue = "";
    }
  }
};
</script>

<style scoped>
#progressbar .completed {
  color: #06a6e0;
}

#progressbar li.completed:before,
#progressbar li.completed:after {
  background: #06a6e0;
}

#grad1 {
  background-color: #fff;
}

#msform {
  text-align: center;
  position: relative;
  margin-top: 20px;
}

#msform fieldset .form-card {
  background: white;
  border: 0 none;
  border-radius: 0px;
  box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
  padding: 20px 40px 30px 40px;
  box-sizing: border-box;
  width: 94%;
  margin: 0 3% 20px 3%;
  position: relative;
}

#msform fieldset {
  padding: 10px;
  background: #e8e8e8;
  border: 0 none;
  border-radius: 2rem;
  box-sizing: border-box;
  width: 100%;
  margin: 0;
  border: 2px solid #ccc;
  padding-bottom: 20px;
  position: relative;
}

#msform fieldset:not(:first-of-type) {
  display: none;
}

#msform fieldset .form-card {
  text-align: left;
  color: #9e9e9e;
}

/* #msform input,
#msform textarea {
    padding: 0px 8px 4px 8px;
    border: none;
    border-bottom: 1px solid #ccc;
    border-radius: 0px;
    margin-bottom: 25px;
    margin-top: 2px;
    width: 100%;
    box-sizing: border-box;
    font-family: montserrat;
    color: #2c3e50;
    font-size: 16px;
    letter-spacing: 1px;
}

#msform input:focus,
#msform textarea:focus {
    -moz-box-shadow: none !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    border: none;
    font-weight: bold;
    border-bottom: 2px solid skyblue;
    outline-width: 0;
} */

#msform .action-button {
  width: 100px;
  background: skyblue;
  font-weight: bold;
  color: white;
  border: 0 none;
  border-radius: 0px;
  cursor: pointer;
  padding: 10px 5px;
  margin: 10px 5px;
}

#msform .action-button:hover,
#msform .action-button:focus {
  box-shadow: 0 0 0 2px white, 0 0 0 3px skyblue;
}

#msform .action-button-previous {
  width: 100px;
  background: #616161;
  font-weight: bold;
  color: white;
  border: 0 none;
  border-radius: 0px;
  cursor: pointer;
  padding: 10px 5px;
  margin: 10px 5px;
}

#msform .action-button-previous:hover,
#msform .action-button-previous:focus {
  box-shadow: 0 0 0 2px white, 0 0 0 3px #616161;
}

select.list-dt {
  border: none;
  outline: 0;
  border-bottom: 1px solid #ccc;
  padding: 2px 5px 3px 5px;
  margin: 2px;
}

select.list-dt:focus {
  border-bottom: 2px solid skyblue;
}

.card {
  z-index: 0;
  border: none;
  border-radius: 0.5rem;
  position: relative;
}

.fs-title {
  font-size: 25px;
  color: #2c3e50;
  margin-bottom: 10px;
  font-weight: bold;
  text-align: left;
}

#progressbar {
  margin-bottom: 30px;
  overflow: hidden;
  color: lightgrey;
}

#progressbar .active {
  color: #000000;
}

#progressbar li {
  list-style-type: none;
  font-size: 12px;
  width: 9.5%;
 text-align: center;
 float:left;
  position: relative;
}

#progressbar #NewTraining:before {
  content: "1";
}

#progressbar #PoAssignment:before {
  content: "2";
}

#progressbar #TrainingInformation:before {
  content: "3";
}
#progressbar #TrainerRegistration:before {
  content: "4a";
}
#progressbar #TrainingAgenda:before {
  content: "4b";
}
#progressbar #Trainingmaterial:before {
  content: "4c";
}

#progressbar #TrainingAssessments:before {
  content: "4d";
}
#progressbar #TraineeRegistration:before {
  content: "4e";
}

#progressbar #AssessmentReview:before {
  content: "5";
}

#progressbar #Completion:before {
  content: "6";
}

#progressbar li:before {
  width: 35px;
  height: 35px;
  line-height: 30px;
  display: block;
  font-size: 18px;
  color: #ffffff;
  background: lightgray;
  border-radius: 50%;
  margin: 0 auto 10px auto;
  padding: 2px;
}

#progressbar li:after {
  content: "";
  width: 100%;
  height: 2px;
  background: lightgray;
  position: absolute;
  left: 0;
  top: 17px;
  z-index: -1;
}

#progressbar li.active:before,
#progressbar li.active:after {
  background: #000000;
}

.radio-group {
  position: relative;
  margin-bottom: 25px;
}

.radio {
  display: inline-block;
  width: 204;
  height: 104;
  border-radius: 0;
  background: lightblue;
  box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  cursor: pointer;
  margin: 8px 2px;
}

.radio:hover {
  box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.3);
}

.radio.selected {
  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
}

.fit-image {
  width: 100%;
  object-fit: cover;
}
</style>
